import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import PlaceHolder from "../../../assets/images/Placeholder.png";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
} from "reactstrap";
import "./LcaCards.css";
import moment from "moment-timezone";
import "moment-timezone/builds/moment-timezone-with-data";
import GitHubForkRibbon from "react-github-fork-ribbon";
import MsgModal from "../modals/MsgModal";
import {
  setActionType,
  setIsMsgModalOpen,
  setSampleAd,
  setSearchPopUp,
  handleActionClick,
  checkExisting, // Import the thunk
} from "../../../redux/slices/SearchBarSlice";
import { setEngagedCouple } from "../../../redux/slices/RequestFormSlice";
import { setLoginPopUp } from "../../../redux/slices/settingSlice";

const BwvBox = ({ ad }) => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [phoneButton, setPhoneButton] = useState("Show Phone Number");
  const navigate = useNavigate();
  const [imageIndex, setImageIndex] = useState({});
  const dispatch = useDispatch();
  const {
    sampleAd,
    isMsgModalOpen,
    actionClickStatus,
    actionClickError,
    checkExistingError,
    checkExistingStatus,
  } = useSelector((state) => state.searchBar);
  const isAdmin = user && user.Role === "admin";
  const logUser = localStorage.getItem("USER_ROLE");
  const isVendor = logUser === "provider" ? user?.UserID : null;

  React.useEffect(() => {
    if (actionClickStatus === "failed" && actionClickError) {
      toast.error(actionClickError);
    }
  }, [actionClickStatus, actionClickError]);
  const isExist = async () => {
    if (islogin) {
      const checkForm = {
        Title: ad?.listName + " (Auto Generated)",
        userId: user.UserID,
      };
      const result = await dispatch(checkExisting(checkForm)).unwrap();
      if (result.data) {
        setPhoneButton(`(800)245-3610 Ext# ${ad.dialExtension}`);
      }
    }
  };
  React.useEffect(() => {
    isExist();
  }, [ad]);
  React.useEffect(() => {
    if (checkExistingStatus === "failed" && checkExistingError) {
      toast.error(checkExistingError);
    }
  }, [checkExistingStatus, checkExistingError]);

  function convertTo12HourFormat(time24) {
    if (!time24) return "";
    const [hour24, minute] = time24.split(":").map(Number);
    if (isNaN(hour24) || isNaN(minute)) return "";
    const period = hour24 >= 12 ? "PM" : "AM";
    const hour12 = (hour24 % 12 || 12).toString().padStart(2, "0");
    return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  const closeModal = () => {
    dispatch(setSampleAd(null));
    dispatch(setIsMsgModalOpen(false));
  };

  function formatDate(inputDate) {
    let date = new Date(inputDate);
    let monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let year = date.getFullYear();
    let month = monthNames[date.getMonth()];
    let day = date.getDate();
    let formattedDay = day < 10 ? "0" + day : day;
    return `${month} ${formattedDay}, ${year}`;
  }

  function convertToUserTimezone(utcTime) {
    let timezone = "America/Los_Angeles";
    if (islogin && user?.TimeZone) {
      timezone = user?.TimeZone.split(",")[0];
    }
    const localTime = moment
      .utc(utcTime)
      .tz(timezone)
      .format("YYYY-MM-DD HH:mm:ss");
    return localTime;
  }

  const handleCardClick = (selectedCard) => {
    const screenWidth = window.innerWidth;
    const isIpadPro = screenWidth === 1024;
    let Id = selectedCard.Id;
    if (!isMsgModalOpen) {
      if (isIpadPro) {
        navigate(`/vendordetails/${Id}`);
      } else {
        window.open(`#/vendordetails/${Id}`, "_blank");
      }
    }
  };

  const handleNextImage = (event, ad) => {
    event.stopPropagation();
    const currentIndex = imageIndex[ad.Id] || 0;
    const images = JSON.parse(ad.Photo);
    const nextIndex = (currentIndex + 1) % images.length;
    setImageIndex({ ...imageIndex, [ad.Id]: nextIndex });
  };

  const handlePrevImage = (event, ad) => {
    event.stopPropagation();
    const currentIndex = imageIndex[ad.Id] || 0;
    const images = JSON.parse(ad.Photo);
    const prevIndex = (currentIndex - 1 + images.length) % images.length;
    setImageIndex({ ...imageIndex, [ad.Id]: prevIndex });
  };

  const handleAction = async (event, action) => {
    event.stopPropagation();
    dispatch(setSampleAd(ad));
    dispatch(setActionType(action));
    if (!islogin) {
      toast.info("Please Login");
      // navigate("/login");
      dispatch(setLoginPopUp(true));
      return;
    }
    const constructedTitle = ad?.listName + " (Auto Generated)";
    const checkForm = {
      Title: constructedTitle,
      userId: user.UserID,
    };
    const result = await dispatch(checkExisting(checkForm)).unwrap();
    const needExists = result.data; // Extract the 'data' field (true/false)
    console.log(needExists, "needExists");
    // Prepare form data for API
    if (isAdmin || isVendor || needExists) {
      if (action === "CALL") {
        const phoneNumber = "8002453610";
        window.location.href = `tel:${phoneNumber}`;
      } else {
        dispatch(setIsMsgModalOpen(true));
      }
      return;
    }
    const form = {
      userId: user.UserID,
      postId: ad.Id,
      postType: 2,
      clickType: action === "CALL" ? 1 : 2,
      createdBy: user.UserID,
    };
    dispatch(handleActionClick(form));
    dispatch(setSearchPopUp(true));
    dispatch(setEngagedCouple(1));
  };

  return (
    <>
      <Card className="shadow-sm position-realtive">
        {ad?.caIdStatus === 100 ? (
          <GitHubForkRibbon color="green" position="left">
            Verified & Trusted
          </GitHubForkRibbon>
        ) : null}
        <Row className="g-0">
          <div
            className="position-absolute"
            style={{
              backgroundColor: "white",
              width: "auto",
              padding: "0 3px 3px 0",
            }}
          >
            <img
              className=""
              style={{ width: "20px" }}
              src={ad?.profilePhoto ? ad?.profilePhoto : PlaceHolder}
              alt={ad?.FullName}
            />
          </div>
          <Col lg="3" md="3" className="d-flex align-items-center">
            <div className="position-relative">
              {ad.Photo && JSON.parse(ad.Photo).length > 1 && (
                <button
                  className="arrow left-arrow position-absolute"
                  style={{
                    top: "50%",
                    left: "3px",
                    transform: "translateY(-50%)",
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    border: "none",
                    fontSize: "30px",
                    zIndex: 1,
                  }}
                  onClick={(event) => handlePrevImage(event, ad)}
                >
                  `` ❮
                </button>
              )}
            </div>
            <img
              className="wc_egcpl-ad img-fluid"
              src={
                ad.Photo && JSON.parse(ad.Photo).length > 0
                  ? JSON.parse(ad.Photo)[imageIndex[ad.Id] || 0]
                  : PlaceHolder
              }
              alt={ad.Title}
              style={{
                objectFit: "fill",
                height: "220px",
                width: "220px",
              }}
            />
            <div className="position-relative">
              {ad.Photo && JSON.parse(ad.Photo).length > 1 && (
                <button
                  className="arrow right-arrow position-absolute"
                  style={{
                    top: "50%",
                    right: "3px",
                    transform: "translateY(-50%)",
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    border: "none",
                    fontSize: "30px",
                    zIndex: 1,
                  }}
                  onClick={(event) => handleNextImage(event, ad)}
                >
                  ❯
                </button>
              )}
            </div>
          </Col>
          <Col lg="7" md="7">
            <CardBody
              onClick={() => handleCardClick(ad)}
              className="lca-card-body"
            >
              <CardTitle
                tag="h5"
                className="mb-2"
                style={{
                  fontSize: "large",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <b>
                  {ad.listName.length > 100
                    ? `${ad.listName.substring(0, 100)}...`
                    : ad.listName}
                </b>
              </CardTitle>
              <CardText style={{ fontSize: "medium", margin: "0px" }}>
                {ad.Description.length > 200
                  ? `${ad.Description.substring(0, 200)}...`
                  : ad.Description}
              </CardText>
              <div className="">
                <CardText
                  className="text-nowrap m-0"
                  style={{ fontSize: "medium" }}
                >
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                  <i>
                    {" "}
                    {ad.Zipcode},{ad?.Location}
                  </i>
                </CardText>
                {ad.categoryName && (
                  <CardText className="" style={{ fontSize: "medium" }}>
                    <b>Service Provided:</b>{" "}
                    {ad.itemName
                      ? ad.itemName
                      : ad.subCategoryName
                      ? ad.subCategoryName
                      : ad.categoryName
                      ? ad.categoryName
                      : ""}
                  </CardText>
                )}
              </div>
              <div>
                <p className="mb-0 posting" style={{ fontSize: "small" }}>
                  Posting Date/Time:{" "}
                  {formatDate(
                    convertToUserTimezone(ad?.updatedAt).split(" ")[0]
                  )}{" "}
                  {convertTo12HourFormat(
                    convertToUserTimezone(ad?.updatedAt).split(" ")[1]
                  )}
                </p>
              </div>
            </CardBody>
          </Col>
          <Col
            lg="2"
            md="2"
            className="d-flex flex-column align-items-center justify-content-center"
          >
            <div className="w-100 text-center need">
              <a
                onClick={(event) => handleAction(event, "CALL")}
                className="btn btn-success btn-sm mb-2 w-100"
              >
                {phoneButton}
              </a>
              <Button
                color="primary"
                size="sm"
                className="w-100"
                onClick={(event) => handleAction(event, "TEXT")}
              >
                Send Message
              </Button>
            </div>
          </Col>
        </Row>
      </Card>
      {sampleAd && (
        <MsgModal
          isOpen={isMsgModalOpen}
          closeModal={closeModal}
          selectedCard={sampleAd}
        />
      )}
    </>
  );
};

export default BwvBox;
